document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px)');

  const setup = () => {
    const headerMenus = document.querySelectorAll('header-menu details');

    headerMenus.forEach((details) => {
      // Evita duplicar listeners si vuelves a cargar el tema
      if (details.dataset.hoverReady) return;
      details.dataset.hoverReady = "true";

      const summary = details.querySelector('summary');
      if (!summary) return;

      let closeTimer;

      const openMenu = () => {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!mq.matches) return;
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 150);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);

      // Accesibilidad (teclado)
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', closeMenu);
    });
  };

  setup();
});
